(function () {
  const STORAGE_KEY = 'vip_offer_verified_email';

  function normalizeEmail(s) {
    return String(s || '')
      .trim()
      .toLowerCase();
  }

  function parseConfig(root) {
    const el = root.querySelector('script[type="application/json"][data-vip-config]');
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
  }

  function parseEmailsFromConfig(cfg) {
    if (!cfg) return [];
    if (Array.isArray(cfg.emails)) {
      return cfg.emails.map(normalizeEmail).filter(Boolean);
    }
    const raw =
      cfg.emailsRaw != null && cfg.emailsRaw !== ''
        ? String(cfg.emailsRaw)
        : cfg.email != null && cfg.email !== ''
          ? String(cfg.email)
          : '';
    return raw
      .split(/[\n\r,;]+/)
      .map(function (s) {
        return normalizeEmail(s);
      })
      .filter(Boolean);
  }

  function cfgHasEmails(cfg) {
    return parseEmailsFromConfig(cfg).length > 0;
  }

  function isEmailAuthorized(cfg, email) {
    const list = parseEmailsFromConfig(cfg);
    if (!list.length) return false;
    const n = normalizeEmail(email);
    return list.indexOf(n) !== -1;
  }

  function getVipQuantityFromFormAndCfg(form, cfg) {
    let q = cfg && cfg.vipQuantity != null ? parseInt(cfg.vipQuantity, 10) : NaN;
    if (!isFinite(q) && form) {
      q = parseInt(form.getAttribute('data-vip-default-qty') || form.dataset.vipDefaultQty || '', 10);
    }
    if (!isFinite(q) || q < 1) q = 5;
    return q;
  }

  function applyVipQuantityToForm(form, cfg) {
    if (!form) return;
    const desired = getVipQuantityFromFormAndCfg(form, cfg);
    const qtyInput =
      form.querySelector('input[name="quantity"].quantity__input') || form.querySelector('input[name="quantity"]');
    if (!qtyInput) return;

    if (qtyInput.type === 'hidden' && !qtyInput.hasAttribute('min')) {
      qtyInput.value = String(Math.max(1, desired));
      qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
      return;
    }

    const min = parseInt(qtyInput.getAttribute('min') || qtyInput.dataset.min || '1', 10);
    const maxAttr = qtyInput.getAttribute('max') || qtyInput.dataset.max;
    const max =
      maxAttr !== null && maxAttr !== '' && maxAttr !== 'null' ? parseInt(maxAttr, 10) : null;
    const step = parseInt(qtyInput.getAttribute('step') || qtyInput.dataset.step || '1', 10);

    let v = Math.max(min, desired);
    if (max != null && isFinite(max)) v = Math.min(v, max);
    if (step > 1) {
      let k = Math.round((v - min) / step);
      v = min + k * step;
      if (max != null && v > max) {
        const maxK = Math.floor((max - min) / step);
        v = min + maxK * step;
      }
      if (v < min) v = min;
    }

    qtyInput.value = String(v);
    qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
    qtyInput.dispatchEvent(new Event('input', { bubbles: true }));
    const qi = qtyInput.closest('quantity-input');
    if (qi && typeof qi.validateQtyRules === 'function') qi.validateQtyRules();
  }

  function applyVipQuantityFromRoot(root) {
    const form = root.querySelector('product-form') || root.closest('product-form');
    if (!form) return;
    const cfg = parseConfig(root);
    applyVipQuantityToForm(form, cfg);
  }

  function getAddToCartLabel() {
    return (window.variantStrings && window.variantStrings.addToCart) || 'Add to cart';
  }

  function unlockProductForm(root) {
    const form = root.querySelector('product-form') || root.closest('product-form');
    if (!form) return;
    form.removeAttribute('data-wanda-atc-locked');
    const variantInput = form.querySelector('input[name="id"].product-variant-id');
    if (variantInput) variantInput.removeAttribute('disabled');
    const submitBtn = form.querySelector('.product-form__submit, button.quick-add__submit[type="submit"]');
    if (submitBtn) {
      submitBtn.removeAttribute('disabled');
      submitBtn.removeAttribute('aria-disabled');
      const span = submitBtn.querySelector('span:not(.sold-out-message):not(.icon-wrap)');
      if (span) span.textContent = getAddToCartLabel();
    }
  }

  function lockProductFormSoldOut(root) {
    const form = root.querySelector('product-form') || root.closest('product-form');
    if (!form) return;
    form.setAttribute('data-wanda-atc-locked', 'true');
    const variantInput = form.querySelector('input[name="id"].product-variant-id');
    if (variantInput) variantInput.setAttribute('disabled', 'disabled');
    const submitBtn = form.querySelector('.product-form__submit, button.quick-add__submit[type="submit"]');
    if (submitBtn) {
      submitBtn.setAttribute('disabled', 'disabled');
      const span = submitBtn.querySelector('span:not(.sold-out-message):not(.icon-wrap)');
      if (span) span.textContent = 'Este producto está agotado';
    }
  }

  /**
   * @param {boolean} variantAvailable - current variant can be added to cart
   */
  function showVerifiedPanel(root, variantAvailable) {
    const verifyForm = root.querySelector('[data-vip-verify-form]');
    const postVerify = root.querySelector('[data-vip-post-verify]');
    const codePromo = root.querySelector('[data-vip-code-promo]');
    const soldOutNotice = root.querySelector('[data-vip-soldout-notice]');

    if (verifyForm) {
      verifyForm.classList.add('hidden');
      verifyForm.setAttribute('aria-hidden', 'true');
    }
    if (postVerify) {
      postVerify.classList.remove('hidden');
      postVerify.setAttribute('aria-hidden', 'false');
    }

    if (variantAvailable) {
      if (codePromo) {
        codePromo.classList.remove('hidden');
        codePromo.setAttribute('aria-hidden', 'false');
      }
      if (soldOutNotice) {
        soldOutNotice.classList.add('hidden');
        soldOutNotice.setAttribute('aria-hidden', 'true');
      }
      unlockProductForm(root);
      applyVipQuantityFromRoot(root);
    } else {
      if (codePromo) {
        codePromo.classList.add('hidden');
        codePromo.setAttribute('aria-hidden', 'true');
      }
      if (soldOutNotice) {
        soldOutNotice.classList.remove('hidden');
        soldOutNotice.setAttribute('aria-hidden', 'false');
      }
      lockProductFormSoldOut(root);
    }
  }

  function isSessionVerified(cfg) {
    if (!cfgHasEmails(cfg)) return false;
    let stored = null;
    try {
      stored = sessionStorage.getItem(STORAGE_KEY);
    } catch (e) {}
    if (!stored) return false;
    return isEmailAuthorized(cfg, stored);
  }

  function attemptVerify(root) {
    const cfg = parseConfig(root);
    if (!cfgHasEmails(cfg)) return;
    const input = root.querySelector('[data-vip-email-input]');
    const err = root.querySelector('[data-vip-verify-error]');
    if (!input) return;
    const entered = normalizeEmail(input.value);
    if (!isEmailAuthorized(cfg, entered)) {
      if (err) {
        err.textContent = 'El correo no coincide. Revisa e inténtalo de nuevo.';
        err.classList.remove('hidden');
      }
      return;
    }
    if (err) {
      err.textContent = '';
      err.classList.add('hidden');
    }
    try {
      sessionStorage.setItem(STORAGE_KEY, entered);
    } catch (e) {}
    const available = cfg.variantAvailable === true;
    showVerifiedPanel(root, available);
  }

  function trySessionUnlock(root, cfg) {
    if (!isSessionVerified(cfg)) return false;
    const available = cfg.variantAvailable === true;
    showVerifiedPanel(root, available);
    return true;
  }

  function initRoot(root) {
    const cfg = parseConfig(root);
    if (!cfgHasEmails(cfg)) return;

    trySessionUnlock(root, cfg);

    const btn = root.querySelector('[data-vip-verify-button]');
    if (btn) {
      btn.addEventListener('click', function () {
        attemptVerify(root);
      });
    }
    const input = root.querySelector('[data-vip-email-input]');
    if (input) {
      input.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') {
          e.preventDefault();
          attemptVerify(root);
        }
      });
    }
  }

  function initAll() {
    document.querySelectorAll('[data-vip-verify-root]').forEach(initRoot);
    document.querySelectorAll('product-form[data-vip-apply-qty-on-load="true"]').forEach(function (form) {
      const cfg = { vipQuantity: parseInt(form.dataset.vipDefaultQty || form.getAttribute('data-vip-default-qty'), 10) };
      applyVipQuantityToForm(form, cfg);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  if (typeof subscribe === 'function') {
    subscribe('variant-change', function (event) {
      if (!event || !event.data || !event.data.variant) return;
      const available = event.data.variant.available === true;

      document.querySelectorAll('[data-vip-logged-in-promo-wrap]').forEach(function (wrap) {
        const codeBlock = wrap.querySelector('[data-vip-show-when-available]');
        const soldBlock = wrap.querySelector('[data-vip-show-when-soldout]');
        if (codeBlock) {
          codeBlock.classList.toggle('hidden', !available);
          codeBlock.setAttribute('aria-hidden', (!available).toString());
        }
        if (soldBlock) {
          soldBlock.classList.toggle('hidden', available);
          soldBlock.setAttribute('aria-hidden', available.toString());
        }
      });

      document.querySelectorAll('[data-vip-verify-root]').forEach(function (root) {
        const cfg = parseConfig(root);
        if (!cfgHasEmails(cfg)) return;
        if (!isSessionVerified(cfg)) return;
        showVerifiedPanel(root, available);
      });

      document.querySelectorAll('product-form[data-vip-default-qty]').forEach(function (form) {
        if (!available) return;
        const verifyRoot = form.querySelector('[data-vip-verify-root]');
        if (verifyRoot) {
          const vcfg = parseConfig(verifyRoot);
          if (!cfgHasEmails(vcfg) || !isSessionVerified(vcfg)) return;
        } else if (!form.hasAttribute('data-vip-apply-qty-on-load')) {
          return;
        }
        applyVipQuantityToForm(form, {
          vipQuantity: parseInt(form.dataset.vipDefaultQty || form.getAttribute('data-vip-default-qty'), 10),
        });
      });
    });
  }

  if (!window.__vipDiscountCopyBound) {
    window.__vipDiscountCopyBound = true;
    document.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('[data-wanda-copy-code]');
      if (!btn) return;
      e.preventDefault();
      var code = btn.getAttribute('data-wanda-copy-code') || '';
      var orig = btn.getAttribute('data-wanda-copy-label') || 'Copiar';
      function done() {
        btn.textContent = '¡Copiado!';
        setTimeout(function () {
          btn.textContent = orig;
        }, 2000);
      }
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(code).then(done).catch(function () {});
      } else {
        var wrap = btn.closest('.wanda-vip-promo');
        var input = wrap && wrap.querySelector('[data-wanda-code-input]');
        if (input) {
          input.select();
          try {
            document.execCommand('copy');
          } catch (err) {}
          done();
        }
      }
    });
  }
})();
